export default {
    approvedHours: {
        error: null,
        loading: false,
        approvableHours: [],
        approvedHours: [],
        cmlmApprovedHours: [],
        unapprovedHoursCount: 0
    },
    attributes: {
        defaultAttributes: [],
        error: null,
        attributes: []
    },
    customers: {
        error: null,
        loading: false,
        syncing: false,
        customers: []
    },
    events: {
        error: [],
        success: [],
        warning: []
    },
    floatingTasks: {
        error: null,
        adminFloatingTasks: [],
        allFloatingTasks: [],
        deletableFloatingTasks: [],
        invalidTasks: []
    },
    customerGroups: {
        active: false,
        error: null,
        loading: false,
        syncing: false,
        customerGroups: [],
        customerGroupProjects: [] //customer groups of this project with year
    },
    logEntries: {
        error: null,
        loading: false,
        commanderCreatedEntries: [],
        commanderErrorMsg: '',
        logEntriesByTimesheet: [],
        logEntriesByTimesheetTasks: [],
        logEntriesOnDate: [],
        logEntriesOnDateForUser: [],
        logEntriesOnWeek: [],
        logEntriesOnWeekForUser: [],
        taskLogEntries: []
    },
    notifications: {
        loading: false,
        notifications: [],
        // const: number of notifications to load from server
        numberOfNotificationsToLoad: 30,
        numberOfUnreadNotifications: 0
    },
    projects: {
        error: null,
        otherProjectsLoading: false,
        loading: false,
        activeProject: null,
        allProjects: [],
        allProjectsWithoutTasks: [],
        archivedProjects: [],
        currentView: null,
        deletable: false,
        myProjectsForWeekApproval: [],
        otherProjectsForWeekApproval: [],
        projects: [],
        projectsForUsersOverview: [],
        projectsByUser: [],
        sameProjects: [],
        selectedProject: null,
        unarchivedProjects: []
    },
    tashi: {
        error: null,
        version: null,
        versionMismatch: false
    },
    tasks: {
        error: null,
        loading: false,
        allTasks: [],
        favoriteTasks: [],
        filteredTasks: [],
        deletable: false,
        mostFrequentlyUsedTasks: [],
        otherTasks: [],
        recentlyAssignedTasks: [],
        selectedTask: null,
        tasks: [],
        tasksByUser: []
    },
    time: {
        time: 0,
    },
    timesheets: {
        error: null,
        loading: false,
        cmlmTimesheets: [],
        currentTimesheet: null,
        timesheets: []
    },
    users: {
        error: null,
        loading: false,
        syncing: false,
        allUsers: [],
        currentUser: null,
        cmlmUsersForStaffOverview: [],
        filteredUser: null,
        filteredUsers: [],
        pms: [],
        regularUsers: [],
        roleFilteredUsers: [],
        selectedUser: null,
        sponsorUsers: [],
        userByID: null,
        usersByTask: [],
        usersForUsersOverview: [],
        usersNoLongerAssigned: []
    },
    userTasks: {
        error: null,
        loading: false,
        filteredUserTasks: [],
        mostFrequentlyUsed: [],
        quotaHistories: [],
        recentlyAssigned: [],
        userTask: null,
        userTasks: [],
        userTasksByUser: []
    },
    weekApprovalUi: {
      myProjectOpen: [],
      otherProjectOpen: [],
      myTaskOpen: [],
      otherTaskOpen: [],
      currentWeek: null
    },
    contracts: {
      contracts: []
    }
};



/** WEBPACK FOOTER **
 ** ./src/app/reducers/initialState.js
 **/